import merge from '~lodash.mergewith'
import { init } from '~@sentry/vue'
import * as CoreSdk from '~@sentry/core'
import * as BrowserSdk from '~@sentry/browser-sdk'
import { ExtraErrorData, ReportingObserver, RewriteFrames } from '~@sentry/integrations'

export { init }
export const SentrySdk = { ...CoreSdk, ...BrowserSdk }

export function getConfig (ctx) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002Fe9de22e0cfcd437d9114c7947e2e0cb5@o160250.ingest.sentry.io\u002F177483",
    environment:"production",
    autoSessionTracking:false,
    release:"tidal-offer-web@1.31.7",
    normalizeDepth:4,
    allowUrls:["https:\u002F\u002Foffer.tidal.com","webpack-internal:\u002F\u002F"],
    ignoreErrors:["checkMRAID","Load failed","MoatMAK","pktAnnotationHighlighter","SelectedDivWithSearchText","supported-color-schemes","webkitExitFullScreen","window.mraid","SecurityError: Blocked a frame with origin","SecurityError: The operation is insecure."],
    beforeSend:function (event, hint) {
        if (hint) {
          const { originalException } = hint;
          if (typeof originalException === 'string' && /^(XhrError|Timeout\b.*)$/.test(originalException)) {
            return null;
          }
          const exception = event.exception?.values?.[0];
          if (exception && originalException instanceof Error) {
            // https://sentry.io/organizations/tidal-music-as/issues/2370885677/
            if (exception.type === 'TypeError' &&
            exception.value?.match(/^(Failed to fetch|NetworkError|Load failed|Could not connect|cancelled)/) &&
            (event.breadcrumbs || []).some((b) =>
            b.level === 'error' &&
            ['fetch', 'xhr'].includes(b.category || '') &&
            b.data?.url.match(/snapchat.com|mczbf.com/))) {
              return null;
            }
          }
        }

        return event;
      },
  }

  config.integrations = [
    new ExtraErrorData(),
    new ReportingObserver({ types:["crash"] }),
    new RewriteFrames(),
  ]

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
